/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>文章管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search">
      <el-form-item label="搜索：">
        <el-input
          size="small"
          v-model="searchForm.title"
          placeholder="输入文章标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <!-- <el-input size="small" v-model="searchForm.name_id" placeholder="选择公司名称"></el-input> -->
        <el-select
          v-model="searchForm.name_id"
          clearable
          placeholder="选择公司名称"
        >
          <el-option
            v-for="item in conpmanyOptions"
            :key="item.value"
            :label="item.name"
            :value="item.name_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select
          v-model="searchForm.states"
          clearable
          @change="changeVal"
          placeholder="选择文章状态"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd()"
          >添加</el-button
        >
        <el-button
          size="small"
          type="danger"
          icon="el-icon-plus"
          @click="batchDel()"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      @select-all="handleSelect"
      @select="handleSelect"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>

      <el-table-column sortable prop="newsId" label="文章Id" width="300">
      </el-table-column>

      <el-table-column sortable prop="newsName" label="文章标题" width="300">
      </el-table-column>

      <!-- <el-table-column sortable prop="art_read" label="阅读量" width="200">
      </el-table-column> -->

      <!-- <el-table-column sortable prop="ups" label="点赞数" width="200">
      </el-table-column> -->

      <!-- <el-table-column sortable prop="states" label="状态" width="200">
        <template slot-scope="scope">
          <div type="text">
            {{ scope.row.states == 0 ? "待发布" : "已发布" }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column sortable prop="time" label="发布时间" width="200">
      </el-table-column>

      <el-table-column sortable prop="url" label="文章跳转路径" width="200">
      </el-table-column>

      <!-- <el-table-column sortable prop="author" label="发布者" width="100">
      </el-table-column> -->

      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFatherTwo="callFatherTwo" @callFather="callFather"></Pagination> -->

    <el-pagination
      class="page-box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="pageparm.index"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageparm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageparm.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { deptSave, deptDelete } from "../../api/userMG";
import {
  delTbArticleList,
  getArticleList,
  getTbArticleList,
} from "../../api/newApis";
import Pagination from "../../components/Pagination";
import { getCompanyList } from "../../api/newApis";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      batchIds: [], //批量删除的id
      title: "添加",
      state: "",
      conpmanyOptions: null,
      options: [
        {
          label: "已发布",
          value: 1,
        },
        {
          label: "待发布",
          value: 0,
        },
      ],
      searchForm: {
        title: "",
        companyName: "",
        states: "",
      },
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入部门代码", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        // index: null,
        // pageSize: null,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    this.getArticle();
    this.getCompany();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeVal(val) {
      console.log(val);
    },
    batchDel() {
      this.$confirm("确定要删除选中的文章吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delTbArticleList(this.batchIds);
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.getArticle();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("已取消删除");
        });
    },

    handleSelect(selection, row) {
      this.batchIds = selection.map((item) => {
        return item.id;
      });
      this.batchIds = this.batchIds.join(",");
    },

    //搜索
    search() {
      console.log(11111, this.searchForm);
      this.getArticleTwo(this.searchForm);
    },

    //获取文章列表方法二
    async getArticleTwo(params) {
      let res = await getTbArticleList(params);
      this.listData = res.data;
      // this.pageparm.total = res.data.total;
      // this.pageparm.pageSize = res.data.pageSize;
      // this.pageparm.index = res.data.index;

      /* this.listData = res.data.list;
      this.pageparm.total = res.data.total;
      this.pageparm.pageSize = res.data.pageSize;
      this.pageparm.index = res.data.index; */
    },

    async getArticle() {
      let params = {
        id: "",
      };
      let res = await getTbArticleList(params);
      console.log(res);
      this.listData = res.data;
    },

    //获取公司列表
    async getCompany() {
      const res = await getCompanyList();
      this.conpmanyOptions = res.data;
      // console.log(res);
    },

    handleSizeChange(val) {
      console.log(this.pageparm);
      this.pageparm.pageSize = val;
      this.getArticle();
      // this.$emit('callFather', this.pageparm)
    },

    handleCurrentChange(val) {
      console.log(this.pageparm);
      this.pageparm.index = val;
      this.getArticle();
    },

    // 获取公司列表
    // getdata(parameter) {
    //   this.loading = true
    //   // 模拟数据开始
    //   let res = {
    //     code: 0,
    //     msg: null,
    //     count: 5,
    //     data: [
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521062371000,
    //         editTime: 1526700200000,
    //         deptId: 2,
    //         deptName: 'XX分公司',
    //         deptNo: '1',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521063247000,
    //         editTime: 1526652291000,
    //         deptId: 3,
    //         deptName: '上海测试',
    //         deptNo: '02',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526349555000,
    //         editTime: 1526349565000,
    //         deptId: 12,
    //         deptName: '1',
    //         deptNo: '11',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526373178000,
    //         editTime: 1526373178000,
    //         deptId: 13,
    //         deptName: '5',
    //         deptNo: '5',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526453107000,
    //         editTime: 1526453107000,
    //         deptId: 17,
    //         deptName: 'v',
    //         deptNo: 'v',
    //         parentId: 1
    //       }
    //     ]
    //   }
    //   this.loading = false
    //   this.listData = res.data
    //   this.pageparm.currentPage = this.formInline.page
    //   this.pageparm.pageSize = this.formInline.limit
    //   this.pageparm.total = res.count
    //   // 模拟数据结束

    //   /***
    //    * 调用接口，注释上面模拟数据 取消下面注释
    //    */
    //   // deptList(parameter)
    //   //   .then(res => {
    //   //     this.loading = false
    //   //     if (res.success == false) {
    //   //       this.$message({
    //   //         type: 'info',
    //   //         message: res.msg
    //   //       })
    //   //     } else {
    //   //       this.listData = res.data
    //   //       // 分页赋值
    //   //       this.pageparm.currentPage = this.formInline.page
    //   //       this.pageparm.pageSize = this.formInline.limit
    //   //       this.pageparm.total = res.count
    //   //     }
    //   //   })
    //   //   .catch(err => {
    //   //     this.loading = false
    //   //     this.$message.error('菜单加载失败，请稍后再试！')
    //   //   })
    // },

    // 分页插件事件
    // callFather(parm) {
    //   this.getArticle(parm)
    // },
    // // 搜索事件
    // search() {
    //   this.getArticle()
    // },

    //去到添加页面
    handleAdd() {
      this.$router.push({ path: "/CPIC/addArticleList" });
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      console.log(index, row);
      localStorage.setItem("editData", JSON.stringify(row));
      this.$router.push({ path: "/CPIC/editArticleList" });
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          deptSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("公司保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delTbArticleList(row.id + "");
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.getArticle();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message.error("已取消删除");
        });
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/CPIC/articleList.vue